<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <!-- <div class="page-top-wrap"> -->
        <div class="top wrap clear">
            <h2 class="bold  float-left">Today English</h2><br>
        </div>
        <!-- </div> -->
        <div class="today-biz">
            <div class="biz-title">
                <div class="wrap">
                    <p>오늘의 비즈니스 영어</p>
                    <h1>{{tod_biz.title}}</h1>
                    <span>{{tod_biz.transtitle}}</span>
                    <img src="../assets/img/mp3.png" @click="btn_play_mp3(tod_biz.mp3url,'biz')" class="cur-pointer" v-if="is_bizplay == false"/>
                    <img src="../assets/img/pause.png" @click="pause('biz')" class="cur-pointer" v-if="is_bizplay == true"/>
                </div>
            </div>
            <div class="biz-wrap">
                <div class="example">
                    <div class="wrap">
                        <p class="title">예문</p>
                        <div v-html="tod_biz.example" class="biz-div">

                        </div>
                        <!-- <ul>
                            <li class="clear">
                                <div>A: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                            <li class="clear">
                                <div>B: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                            <li class="clear">
                                <div>A: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="translation">
                    <div class="wrap">
                        <p class="title">번역</p>
                        <div v-html="tod_biz.transexample" class="biz-div">

                        </div>
                        <!-- <ul>
                            <li class="clear">
                                <div>A: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                            <li class="clear">
                                <div>B: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                            <li class="clear">
                                <div>A: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="commentary">
                    <div class="wrap">
                        <p class="title">해설</p>
                        <div v-html="tod_biz.content" class="commentary-body">

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="today-to">
            <div class="to-title">
                <div class="wrap">
                    <p>오늘의 한마디</p>
                    <h1>{{tod_daily.title}}</h1>
                    <span>{{tod_daily.transtitle}}</span>
                    <img src="../assets/img/mp3.png" @click="btn_play_mp3(tod_daily.mp3url,'today')" class="cur-pointer" v-if="is_todayplay == false"/>
                    <img src="../assets/img/pause.png" @click="pause('today')" class="cur-pointer" v-if="is_todayplay == true"/>
                </div>
            </div>
            <div class="to-wrap">
                <div class="example">
                    <div class="wrap">
                        <p class="title">예문</p>
                        <div v-html="tod_daily.example" class="biz-div">

                        </div>
                        <!-- <ul>
                            <li class="clear">
                                <div>A: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                            <li class="clear">
                                <div>B: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                            <li class="clear">
                                <div>A: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="translation">
                    <div class="wrap">
                        <p class="title">번역</p>
                        <div v-html="tod_daily.transexample" class="biz-div">

                        </div>
                        <!-- <ul>
                            <li class="clear">
                                <div>A: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                            <li class="clear">
                                <div>B: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                            <li class="clear">
                                <div>A: </div>
                                <p>All these deadlines are really getting to me. I really need R&R (rest & relaxation).</p>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="commentary">
                    <div class="wrap">
                        <p class="title">해설</p>
                        <p class="commentary-body" v-html="tod_daily.content">
                            <!-- Get to (somebody) 누구를 괴롭히거나, 누구에게 영향을 미치다 란 뜻입니다. 주로 구어체에서 사용되는 표현으로 대화내용에서는 어떤 일을 신경 쓰지 않으려고 하는데도 불구하고 짜증이 나려고 하고, 화가 나려고 한고, 신경이 예민해 지는 상황을 표현하고 있습니다. 그래서 All these deadlines (이 모든 마감일들이) 즉, 마감일들에 대한 부담감이 are getting to me. (내 신경을 거슬려 짜증나기 시작했다.) 란 표현이 됩니다. -->
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn">
            <button class="btn-base-white" @click="goTop()"><span>Top <img src="../assets/img/arrow-top-gray.png" /></span></button>
        </div>
    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'todayEng',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    data: () => ({
        tod_biz: {
            seq: 1,
            view_date: "2018-01-12",
            mp3url: "",
            title: "Don’t be too harsh on them.",
            transtitle: "너무 강하게 하지 말라고.",
            example: "A: Peter, did you have a chance to look over the resumes? B: Of course. I think they learnt well on how to write a resume at college. A: Well then it’s time to find out how well they are prepared for the interview. B: Don’t be too harsh on them.",
            transexample: "A: 피터, 이력서 검토는 해 봤어요? B: 당연하죠. 대학에서 이력서 작성하는 법을 제대로 배운 듯 해요. A: 그럼 이제 면접을 얼마나 잘 준비해 왔는지 확인할 차례네요. B: 너무 강하게 하지 말라고.",
            content: "Harsh on somebody는 누구에게 (부당하게) 나무라다, 누구에게 잔소리하다, 듣기 싫은 소리를 하다 란 뜻입니다. 대화내용에서는 반 농담조로 면접 온 사람들에게 너무 지나치게 강하게 하지 말고, 살살 하라는 뜻으로 Don’t be too harsh on them. 이라고 표현하였습니다. 간혹 회화체에서 애들 너무 잡지 마세요~ 라고 할 때 이 표현을 그대로 사용하셔도 됩니다. 비슷한 표현으로는 Go easy on them. 관대하게 하라, 살살 다뤄라, 너무 심하게 하지 마라 란 표현입니다."
        },
        tod_daily: {
            seq: 1,
            mp3url: "",
            title: "He got me off the hook before.",
            transtitle: "그는 전에 저를 위기에서 구해 주었습니다.",
            example: "A: Are you sure Steve can help you? B: Yeah. He got me off the hook before. A: How did you get acquainted with him? B: We went to college together. A: He must be a good friend.",
            transexample: "A: 스티브가 도와줄 수 있는거 확실해요? B: 네. 전에도 저를 위기에서 구해 줬어요. A: 어떻게 그를 알게 되었습니까? B: 우리 같은 대학 다녔어요. A: 좋은 친구인 것 같네요.",
            content: "`위기에서 구하다´ 라는 표현으로 get someone off the hook 라는 표현을 사용할 수 있습니다. hook 는 ´갈고리, 고리´ 라는 표현으로 주로 사용되지만 off the hook 라고 하면 ´곤란한 상황이나 의무 등에서 벗어남´ 을 의미합니다. 한편 get acquainted with~ 는 ´~와 아는 사이가 되다, ~를 알고 있다´ 의 의미이며, have acquaintance with~ 는 ´~와 안면(면식)이 있다´ 의 표현입니다."
        },
        audio: "",
        is_bizplay:false,
        is_todayplay:false,

        is_first_bizplay:false,
        is_first_todayplay:false
    }),
    mounted() {
        //    this.doc_del_rendar();
        this.getTodayEnglish();
    },
    methods: {
        // changeTab(target) {
        //     this.tab = target;
        // }
        pause:function(gubun){
            if (this.audio != '') {
                this.audio.pause();
            }
            if(gubun == 'biz'){
                this.is_bizplay = false;
            }else{
                this.is_todayplay = false;
            }
        },
        play: function (audio,gubun) {
            audio.play();
            var me = this;
            return new Promise(function (resolve, reject) {
                audio.addEventListener('ended', function(){
                    if(gubun == 'biz'){
                        me.is_bizplay = false;
                    }else{
                        me.is_todayplay = false;
                    }
                });
                console.log(audio);
                console.log(resolve);
                console.log(reject);
            });
        },

        btn_play_mp3: function (mp3,gubun) {
            console.info(this.audio);
            console.log(mp3);
            if(gubun == 'biz' && this.audio == ""){
                this.is_first_bizplay = true;
            }else if(gubun == 'today' && this.audio == ""){
                this.is_first_todayplay = true;
            }

            if (this.audio != '') {
                this.audio.pause();
                
                // return "";
            }
            if(gubun == 'biz'){
                this.is_bizplay = true;
               
                if(this.audio != '' && this.is_first_bizplay == true){
                    this.audio.play();
                    return "";
                }
            }else{
                this.is_todayplay = true;
                if(this.audio != '' && this.is_first_todayplay == true){
                    this.audio.play();
                    return "";
                }
            }
            this.audio = new Audio(mp3);
            return this.play(this.audio,gubun);
        },
        goTop() {
            window.scrollTo(0, 0);
        },
        getTodayEnglish: function () {
            var me = this;
            this.axios.get(this.$store.state.host + '/rest/mobile/todayEnglish').then(function (res) {
                // console.log(res.data.biz);
                if (res.data.err == 0) {
                    me.tod_biz = res.data.biz;
                    me.tod_daily = res.data.daily;

                    console.log(me.tod_biz);
                }
            });
        },
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    padding-bottom: 30px;
    // width: 1200px;
    margin: 0 auto;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }

    // .page-top-wrap {
    //     width: 100%;

    .top {
        // padding-right: 20px;
        padding-bottom: 17px;
        padding-top: 70px;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;
        position: relative;

        .my-reason {
            position: absolute;
            right: 0;
            bottom: 15%;
        }

        p {
            font-size: 14px;
            letter-spacing: 0px;
            color: #000000;
            opacity: 1;
        }

        div {
            select {
                border: 1px solid var(--unnamed-color-53caff);
                background: #FFFFFF 0% 0% no-repeat padding-box;
                border: 1px solid #53CAFF;
                border-radius: 4px;
                opacity: 1;
                color: #53CAFF;
                ;
            }
        }

        .wrap {
            width: 90%;
            max-width: 700px;
        }
    }

    // }

    .page-top {
        border-bottom: 1px solid #E9E9E9;
    }

    .today-biz {
        .biz-title {
            width: 100%;
            background: transparent url("../assets/img/today_img1_3.png") no-repeat;
            background-position-y: -100px;
            background-size: 100%;
            padding-top: 15px;
            padding-bottom: 15px;
            max-height: 148px;
            height: 148px;
            max-width: 700px;
            margin: 0 auto;

            .wrap {
                position: relative;

                p {
                    font-size: 14px;
                    font-weight: bold;
                    letter-spacing: 0px;
                    color: #FFFFFF;
                    opacity: 0.7;
                }

                h1 {
                    font-size: 18px;
                    letter-spacing: 0px;
                    color: #FFFFFF;
                    opacity: 1;
                    margin-top: 10px;
                }

                span {
                    margin-top: 10px;
                    font-size: 14px;
                    letter-spacing: -0.28px;
                    color: #FFFFFF;
                    opacity: 1;
                }

                img {
                    position: absolute;
                    right: 0px;
                    top: 0px;
                    width: 20px;
                }
            }
        }

        .biz-wrap {
            .example {
                padding-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px dashed #E9E9E9;
                max-width: 700px;
                margin: 0 auto;

                .wrap {
                    width: 100%;
                }

                .biz-div {
                    font-size: 14px;
                    line-height: 25px;
                    white-space: pre-wrap;
                    width: 100%;
                    font-weight: normal;

                    span {
                        font-size: 14px;
                        font-weight: bold;
                        letter-spacing: -0.28px;
                        color: #53CAFF;
                        opacity: 1;
                        width: 30px;
                        float: left;
                        ;
                    }
                }
            }

            .translation {
                padding-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px dashed #E9E9E9;
                max-width: 700px;
                margin: 0 auto;

                .wrap {
                    width: 100%;
                }

                .biz-div {
                    font-size: 14px;
                    line-height: 25px;
                    white-space: pre-wrap;
                    width: 100%;
                    font-weight: normal;

                    span {
                        font-size: 14px;
                        font-weight: bold;
                        letter-spacing: -0.28px;
                        color: #53CAFF;
                        opacity: 1;
                        width: 30px;
                        float: left;
                        ;
                    }
                }
            }

            .commentary {
                padding-top: 20px;
                padding-bottom: 20px;
                max-width: 700px;
                margin: 0 auto;

                .wrap {
                    width: 100%;
                }

                .commentary-body {
                    text-align: left;
                    font-size: 14px;
                    letter-spacing: -0.28px;
                    color: #000000;
                    opacity: 1;
                }

            }

            .wrap {
                .title {
                    font-size: 14px;
                    letter-spacing: -0.28px;
                    color: #000000;
                    opacity: 1;
                    font-weight: bold;
                }

                ul {
                    li {
                        padding-top: 10px;

                        div {
                            font-size: 14px;
                            font-weight: bold;
                            letter-spacing: -0.28px;
                            color: #53CAFF;
                            opacity: 1;
                            width: 30px;
                            float: left;
                        }

                        p {
                            float: left;
                            width: 90%;
                            font-size: 14px;
                            letter-spacing: -0.28px;
                            color: #000000;
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }

    .today-to {
        .to-title {
            width: 100%;
            background: transparent url("../assets/img/today_img2_1.png") no-repeat;
            background-position-y: -100px;
            background-size: 100%;
            padding-top: 15px;
            padding-bottom: 15px;
            max-height: 148px;
            height: 148px;
            max-width: 700px;
            margin: 0 auto;

            .wrap {
                position: relative;

                p {
                    font-size: 14px;
                    font-weight: bold;
                    letter-spacing: 0px;
                    color: #FFFFFF;
                    opacity: 0.7;
                }

                h1 {
                    font-size: 18px;
                    letter-spacing: 0px;
                    color: #FFFFFF;
                    opacity: 1;
                    margin-top: 10px;
                }

                span {
                    margin-top: 10px;
                    font-size: 14px;
                    letter-spacing: -0.28px;
                    color: #FFFFFF;
                    opacity: 1;
                }

                img {
                    position: absolute;
                    right: 0px;
                    width: 20px;
                    top: 0px;
                }
            }
        }

        .to-wrap {
            .example {
                padding-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px dashed #E9E9E9;
                width: 700px;
                margin: 0 auto;

                .wrap {
                    width: 100%;
                }

                .biz-div {
                    font-size: 14px;
                    line-height: 25px;
                    white-space: pre-wrap;
                    width: 100%;
                    font-weight: normal;

                    span {
                        font-size: 14px;
                        font-weight: bold;
                        letter-spacing: -0.28px;
                        color: #53CAFF;
                        opacity: 1;
                        width: 30px;
                        float: left;
                        ;
                    }
                }
            }

            .translation {
                padding-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px dashed #E9E9E9;
                width: 700px;
                margin: 0 auto;

                .wrap {
                    width: 100%;
                }

                .biz-div {
                    font-size: 14px;
                    line-height: 25px;
                    white-space: pre-wrap;
                    width: 100%;
                    font-weight: normal;

                    span {
                        font-size: 14px;
                        font-weight: bold;
                        letter-spacing: -0.28px;
                        color: #53CAFF;
                        opacity: 1;
                        width: 30px;
                        float: left;
                        ;
                    }
                }
            }

            .commentary {
                padding-top: 20px;
                padding-bottom: 20px;
                width: 700px;
                margin: 0 auto;

                .wrap {
                    width: 100%;
                }

                .commentary-body {
                    text-align: left;
                    font-size: 14px;
                    letter-spacing: -0.28px;
                    color: #000000;
                    opacity: 1;
                }
            }

            .wrap {
                .title {
                    font-size: 14px;
                    letter-spacing: -0.28px;
                    color: #000000;
                    opacity: 1;
                    font-weight: bold;
                }

                ul {
                    li {
                        padding-top: 10px;

                        div {
                            font-size: 14px;
                            font-weight: bold;
                            letter-spacing: -0.28px;
                            color: #6974FF;
                            opacity: 1;
                            width: 30px;
                            float: left;
                        }

                        p {
                            float: left;
                            width: 90%;
                            font-size: 14px;
                            letter-spacing: -0.28px;
                            color: #000000;
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
}

.btn {
    width: 90%;
    margin: 0 auto;
    max-width: 700px;
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;

        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;
            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }

            &.wrap {
                width: 100%;
                padding-left: 5%;
            }
        }

        .today-biz {
            .biz-title {
                background-position-y: 0px;
            }

            .biz-wrap {
                .example {
                    // width: 1200;
                    width: 100%;

                    .wrap {
                        width: 90%;
                        margin: 0 auto;
                    }
                }

                .translation {
                    width: 100%;

                    .wrap {
                        width: 90%;
                        margin: 0 auto;
                    }
                }

                .commentary {
                    width: 100%;

                    .wrap {
                        width: 90%;
                        margin: 0 auto;
                    }
                }
            }
        }

        .today-to {
            .to-title {
                background-position-y: 0px;
            }

            .to-wrap {
                .example {
                    // width: 1200;
                    width: 100%;

                    .wrap {
                        width: 90%;
                        margin: 0 auto;
                    }
                }

                .translation {
                    width: 100%;

                    .wrap {
                        width: 90%;
                        margin: 0 auto;
                    }
                }

                .commentary {
                    width: 100%;

                    .wrap {
                        width: 90%;
                        margin: 0 auto;
                    }
                }
            }
        }
    }

}
</style>
